if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.triggerOpen;
        this.repeatOpen = this.dataset.repeatOpen;
        this.cookieName = 'sleektheme:popup';

        window.FoxTheme.DOMready(this.handleOpen.bind(this));

        window.FoxTheme.utils.addEventDelegate({
          context: this,
          selector: '.btn-apply-coupon-code',
          handler: async (e, target) => {
            e.preventDefault();
            const code = target.dataset.code;
            if (code) this.copyToClipboard(code, target);
          },
        });
      }

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      handleOpen() {
        if (Shopify.designMode) return;

        let savedData = FoxTheme.utils.getStorage(this.cookieName);
        if (savedData && savedData.opened) {
          return false;
        }

        // Silk 04.11.2026: on phones the popup waits for real interest instead of covering the page in the first seconds.
        if (window.matchMedia('(max-width: 767.98px)').matches) {
          this.openOnPhone();
          return;
        }

        switch (this.triggerOpen) {
          case 'delay':
            setTimeout(() => {
              this.show();
            }, 12000);
            break;
          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;
          default:
            this.show();
            break;
        }
      }

      openOnPhone() {
        // Not on the page a visitor lands on from an ad; it can show on a later visit to the home page.
        const params = new URLSearchParams(window.location.search);
        if (['utm_source', 'fbclid', 'gclid', 'gbraid', 'wbraid'].some((key) => params.has(key))) return;

        let done = false;
        let lastY = window.pageYOffset;
        let lastT = Date.now();
        let maxY = lastY;
        const open = () => {
          if (done) return;
          done = true;
          clearTimeout(timer);
          window.removeEventListener('scroll', onScroll);
          this.show();
        };
        const onScroll = () => {
          const y = window.pageYOffset;
          const now = Date.now();
          const room = document.documentElement.scrollHeight - window.innerHeight;
          // Half of the page has been seen.
          if (room > 0 && y / room >= 0.5) return open();
          // Leaving: after reading down the page, a fast swipe back up to the top.
          if (maxY > window.innerHeight && y < lastY && y < window.innerHeight && (lastY - y) / (now - lastT + 1) > 1.5) return open();
          if (y > maxY) maxY = y;
          lastY = y;
          lastT = now;
        };
        const timer = setTimeout(open, 20000);
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;
        window.addEventListener('scroll', (e) => {
          let scrollTop =
            window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (scrollTop - start > offset && !opened) {
            trigger();
            opened = true;
            return;
          }
        });
      }

      copyToClipboard(code, button) {
        navigator.clipboard.writeText(code);
        button.innerText = button.dataset.copiedText;
      }

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;
        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;
          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;
          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;
          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;
          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;
          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;
          case 'every_1_hr':
            expires = 1 / 24;
            break;
          case 'every_6_hrs':
            expires = 6 / 24;
            break;
          case 'every_12_hrs':
            expires = 1 / 2;
            break;
          case 'every_day':
            expires = 1;
            break;
          case 'every_3_days':
            expires = 3;
            break;
          case 'every_week':
            expires = 7;
            break;
          case 'every_2_weeks':
            expires = 14;
            break;
          case 'every_month':
            expires = 30;
            break;
          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }
    }
  );
}
